// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal__modal1BN","modal--transparent":"modal__modal--transparent3HW","close":"modal__close2yW"};